import api from "../../../../api";
import React, { useEffect, useState } from "react";
import values from "../../../../values";
import Context from "../../../../context";

import * as Yup from "yup";

import { useFormik } from "formik";
import { useQuery } from "react-query";
import { ICreateAndUpdateUser } from "../../../../types/common.interface";
import { ICreateAndUpdateSuperAgent } from "../../../../types/superAgent.interface";
import {
  CustomButton2,
  CustomCheckBox,
  CustomDropdownSearch,
  CustomInput,
  CustomModal,
  CustomView,
} from "../../../../components";

import "./index.sass";
import TitleLine from "../../../../components/TitleLine";
import validations from "../../../../validations";
import utils from "../../../../utils";
import { useTranslation } from "react-i18next";

const Update = () => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal, updateFunction, isLoading, selectedUser } =
    React.useContext(Context.UserScreen);

  const [access, setAccess] = useState<any>({
    financial: selectedUser?.permission?.financial,
    write: selectedUser?.permission?.write,
  });

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! -----------------------------------------------------------------------------------------------------------

  // !! -----------------------------------------------------------------------------------------------------------
  // !!                                             End API Call
  // !! ===========================================================================================================

  // ?? ===========================================================================================================
  // ??                                           Use Formik Function
  // ?? -----------------------------------------------------------------------------------------------------------

  useEffect(() => {
    setAccess({
      financial: selectedUser?.permission?.financial
        ? selectedUser?.permission?.financial
        : false,
      write: selectedUser?.permission?.write
        ? selectedUser?.permission?.write
        : false,
    });
  }, [selectedUser?._id]);

  const formik = useFormik<ICreateAndUpdateUser>({
    enableReinitialize: true,
    initialValues: {
      _id: selectedUser?._id ? selectedUser._id : "",
      firstName: selectedUser?.firstName ? selectedUser?.firstName : "",
      lastName: selectedUser?.lastName ? selectedUser.lastName : "",
      phoneNumber: selectedUser?.phoneNumber ? selectedUser.phoneNumber : "",
    },
    validationSchema: Yup.object({
      // validation
      firstName: validations.yupValidations.firstName,
      lastName: validations.yupValidations.lastName,
      phoneNumber: validations.yupValidations.phoneNumber,
    }),
    onSubmit: (values: ICreateAndUpdateUser, { setSubmitting }) => {
      // if (!selectedProvince) return utils.errorHandler(9011);
      // if (!selectedCity) return utils.errorHandler(9012);
      const formValues: ICreateAndUpdateUser = {
        permission: {
          ...access,
        },
        ...values,
      };
      Promise.resolve(updateFunction(formValues))
        .then(() => {})
        .catch((e) => setSubmitting(false));
    },
  });

  function submitHandler() {
    formik.submitForm();
  }

  function closeHandler() {
    setShowModal("NONE");
  }

  const { t } = useTranslation();

  // ?? ===========================================================================================================
  // ??                                               JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="super-agent-update-modal-container">
      <form onSubmit={submitHandler} id="create-user-modal">
        <CustomModal
          onClose={() => setShowModal("NONE")}
          open={showModal === "UPDATE"}
        >
          <CustomView.Container className="create-form-content">
            <CustomView.Row className="form-row">
              <CustomView.Column medium={6} className="form-colum">
                <CustomInput
                  name="firstName"
                  id="firstName"
                  label={t("firstName")}
                  value={formik.values.firstName}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={formik.errors.firstName && formik.touched.firstName}
                  errorText={formik.errors.firstName}
                />
              </CustomView.Column>{" "}
              <CustomView.Column medium={6} className="form-colum">
                <CustomInput
                  name="lastName"
                  id="lastName"
                  label={t("lastName")}
                  value={formik.values.lastName}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={formik.errors.lastName && formik.touched.lastName}
                  errorText={formik.errors.lastName}
                />
              </CustomView.Column>
              <CustomView.Column medium={6} className="form-colum">
                <CustomInput
                  name="phoneNumber"
                  id="phoneNumber"
                  label={t("phoneNumber")}
                  value={utils.convertNumbers2English(
                    formik.values.phoneNumber as string
                  )}
                  onValueChange={formik.handleChange}
                  formikProps={{ onBlur: formik.handleBlur }}
                  error={
                    formik.errors.phoneNumber && formik.touched.phoneNumber
                  }
                  errorText={formik.errors.phoneNumber}
                  maxLength={11}
                />
              </CustomView.Column>
              <CustomView.Column medium={6} className="form-colum dropdown">
                <div className="access-container">
                  <div className="input-label right">{t("access")}</div>
                  <div>
                    <CustomCheckBox
                      label={t("financial")}
                      isChecked={access?.financial}
                      onChecked={() =>
                        setAccess({ ...access, financial: !access.financial })
                      }
                    />{" "}
                    <CustomCheckBox
                      label={t("update")}
                      isChecked={access?.write}
                      onChecked={() =>
                        setAccess({ ...access, write: !access.write })
                      }
                    />
                  </div>
                </div>
              </CustomView.Column>
            </CustomView.Row>

            <CustomView.Row className="form-row buttons-group">
              <CustomView.Column
                large={3}
                medium={4}
                small={6}
                className="form-colum"
              >
                <CustomButton2
                  isLoading={isLoading}
                  onClick={closeHandler}
                  title={t("cancel")}
                  type="danger"
                />
              </CustomView.Column>
              <CustomView.Column
                large={3}
                medium={4}
                small={6}
                className="form-colum"
              >
                <CustomButton2
                  isLoading={isLoading}
                  onClick={submitHandler}
                  title={t("submit")}
                />
              </CustomView.Column>
            </CustomView.Row>
          </CustomView.Container>
        </CustomModal>
      </form>
    </section>
  );
};

export default Update;
